import { CrewListScreen, CrewProfileScreen, LoginAccountsScreen, SignOnOffScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Shell } from '../components/Shell.js';
import { officeLoginAccountsSource } from '../login-accounts-source.js';
import { officeSource } from '../personnel-source.js';

/** Personel listesi (ortak ekran `CrewListScreen`; ADR 0012 §5): ofiste filonun tamamı. */
export function CrewPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('crew.title')}>
      <CrewListScreen source={officeSource} />
    </Shell>
  );
}

/**
 * Crew Profile (`/crew/profile/:userId`; ADR 0131 §2): menüde değil, Crew List'ten açılır; sol
 * menüde Crew List vurgulu kalır (yol `/crew` altında).
 */
export function CrewProfilePage() {
  const { t } = useTranslation();
  const { userId = '' } = useParams();
  return (
    <Shell title={t('crewProfile.title')}>
      <CrewProfileScreen key={userId} source={officeSource} userId={userId} />
    </Shell>
  );
}

/** Crew ▸ Sign On / Off (ADR 0131 §3; `gemi-personel.jpeg` panel 5): ofiste kayıt. */
export function SignOnOffPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('signOnOff.title')}>
      <SignOnOffScreen source={officeSource} />
    </Shell>
  );
}

/**
 * Crew ▸ Login Accounts (`/crew/login-accounts`; sahip 2026-11-01, ADR 0147): giriş hesapları ve
 * gemide bugün kimin girebileceği.
 */
export function LoginAccountsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('loginAccounts.title')}>
      <LoginAccountsScreen source={officeLoginAccountsSource} />
    </Shell>
  );
}
